import Request from './request';

export const getFeedbacks = async () => {
  return Request.call({
    url: 'api/v1/feedback/',
    method: 'GET',
  });
};